"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LogSkeleton = _interopRequireWildcard(require("../LogSkeleton"));
var _excluded = ["size"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CommunicationListSkeleton = /*#__PURE__*/function (_React$PureComponent) {
  function CommunicationListSkeleton(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CommunicationListSkeleton);
    _this = _callSuper(this, CommunicationListSkeleton, [props]);
    _this.state = {
      itemCount: 0
    };
    _this.wrapper = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  (0, _inherits2["default"])(CommunicationListSkeleton, _React$PureComponent);
  return (0, _createClass2["default"])(CommunicationListSkeleton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var wrapperSize = (0, _get2["default"])(this.wrapper.current, 'clientHeight') || 0;
      var itemCount = Math.ceil(wrapperSize / 62);
      this.setState({
        itemCount: itemCount
      });
    }
  }, {
    key: "render",
    value: function render() {
      var itemCount = this.state.itemCount;
      var _this$props = this.props,
        size = _this$props.size,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledLogSkeleton, (0, _extends2["default"])({
        ref: this.wrapper
      }, props), (0, _toConsumableArray2["default"])(Array(itemCount)).map(function () {
        return /*#__PURE__*/_react["default"].createElement(_LogSkeleton["default"], {
          size: size
        });
      }));
    }
  }]);
}(_react["default"].PureComponent);
CommunicationListSkeleton.propTypes = {
  className: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(Object.values(_LogSkeleton.SIZES))
};
CommunicationListSkeleton.defaultProps = {
  className: '',
  size: _LogSkeleton.SIZES.MEDIUM
};
var StyledLogSkeleton = _styledComponents["default"].div.withConfig({
  displayName: "LogListSkeleton__StyledLogSkeleton",
  componentId: "sc-1iawoxc-0"
})(["height:100%;"]);
var _default = exports["default"] = CommunicationListSkeleton;